import { CSSProperties } from 'react';
import './ProcessBar.css';

interface LoadingBarProps {
  speed?: number;
  className?: string;
  style?: CSSProperties;
}

const LoadingBar = ({ speed = 5, className, style }: LoadingBarProps) => {
  return (
    <div
      id="loading-bar"
      className={className}
      style={{
        animationDuration: `${speed}s`,
        ...style,
      }}
    />
  );
};

export default LoadingBar;
